import { render } from "./circle-loader.vue?vue&type=template&id=38af407f&ts=true"
import script from "./circle-loader.vue?vue&type=script&lang=ts"
export * from "./circle-loader.vue?vue&type=script&lang=ts"

import "./circle-loader.vue?vue&type=style&index=0&id=38af407f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__